import React from 'react';
import styles from './MissionCard.module.css';

interface Mission {
  id: number;
  missionId: number;
  name: string;
  description: string;
  missionType: string;
  requirement: number;
  progress: number;
  silverReward: number;
  xpReward: number;
  isClaimed: boolean;
  isCompleted: boolean;
}

interface MissionCardProps {
  mission: Mission;
  onReroll: () => void;
  isRerolling: boolean;
  onClaim: () => void;
  isClaiming: boolean;
}

export default function MissionCard({ mission, onReroll, isRerolling, onClaim, isClaiming }: MissionCardProps) {
  const progressPercent = Math.min((mission.progress / mission.requirement) * 100, 100);

  return (
    <div className={`${styles.card} ${mission.isCompleted ? styles.completed : ''} ${mission.isClaimed ? styles.claimed : ''}`}>
      <div className={styles.cardHeader}>
        <h3 className={styles.title}>{mission.name}</h3>
        {mission.isClaimed && <span className={styles.claimedBadge}>Claimed</span>}
        {mission.isCompleted && !mission.isClaimed && <span className={styles.completedBadge}>Complete</span>}
      </div>

      <p className={styles.description}>{mission.description}</p>

      <div className={styles.progressSection}>
        <div className={styles.progressLabel}>
          <span>Progress</span>
          <span className={styles.progressText}>
            {mission.progress} / {mission.requirement}
          </span>
        </div>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      <div className={styles.rewards}>
        <div className={styles.reward}>
          <span className={styles.rewardLabel}>Silver</span>
          <span className={styles.rewardAmount}>{mission.silverReward}</span>
        </div>
        <div className={styles.reward}>
          <span className={styles.rewardLabel}>XP</span>
          <span className={styles.rewardAmount}>{mission.xpReward}</span>
        </div>
      </div>

      {!mission.isClaimed && !mission.isCompleted && (
        <button
          className={styles.rerollButton}
          onClick={onReroll}
          disabled={isRerolling}
          title="Reroll this mission (once per day)"
        >
          {isRerolling ? 'Rerolling...' : 'Reroll'}
        </button>
      )}

      {mission.isCompleted && !mission.isClaimed && (
        <button
          className={styles.claimButton}
          onClick={onClaim}
          disabled={isClaiming}
        >
          {isClaiming ? 'Claiming...' : 'Claim Reward'}
        </button>
      )}
    </div>
  );
}
